<div class="empty-message-hero-container" *ngIf="!isArchivedView">
  <img
    class="lists-image"
    src="./assets/images/list-grid-empty-state.png"
    alt="Image representing a few inactive lists"
  />
  <section class="empty-message-text-container">
    <h1 class="empty-message-title" i18n>No lists have been created yet.</h1>
    <p *ngIf="(canAddList$ | async)" class="empty-message-subtitle" i18n>You can be the first to create a list!</p>
  </section>
  <section class="empty-controls-container">
    <a *ngIf="(canAddList$ | async)" routerLink="../new" class="empty-state-button add-list-button">
      <span>Add List</span>
    </a>
    <a
      href="https://intercom.help/dashpivot/en/articles/2563225-lists"
      target="_blank"
      rel="noopener noreferrer"
      class="empty-state-button learn-more-button"
    >
      <em class="cc-icon cc-icon-question"></em>
      <span>Learn more</span>
    </a>
  </section>
</div>

<div class="empty-message-hero-container" *ngIf="isArchivedView">
  <img
    class="lists-image"
    src="./assets/images/list-grid-empty-state.png"
    alt="Image representing a few inactive lists"
  />
  <section class="empty-message-text-container">
    <h1 class="empty-message-title" i18n>No lists have been archived yet.</h1>
    <p class="empty-message-subtitle" i18n>
      You can still access the active lists via the active/archived toggle above.
    </p>
  </section>
</div>
